import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useDesignSystem } from "../context/designSystemContext";
import { Categories } from "../types/categories";
import { pSBC } from "../utils/pSBC";

export const RiskList = ({ riskData }: { riskData: Categories[] }) => {
    const [groupedData, setGroupedData] = useState<any[][]>([]);

    const { designSystem } = useDesignSystem();

    // Ordenando riskData para que os itens com prioridade "HIGH" venham primeiro
    const sortedRiskData = riskData.sort((a, b) => {
        const priorityOrder: { [key: string]: number } = { "HIGH": 1, "REGULAR": 2, "LOW": 3 };
        return priorityOrder[a.priority] - priorityOrder[b.priority];
    });

    // agrupando tudo em uma lista de categoria com lista de subcategorias
    useEffect(() => {
        const groupData = () => {
            // Agrupamento por categoria e subcategoria
            const groupedByCategory = sortedRiskData.reduce((acc: any, item: any) => {
                if (!acc[item.category]) {
                    acc[item.category] = {};
                }
                if (!acc[item.category][item.subcategory]) {
                    acc[item.category][item.subcategory] = [];
                }
                acc[item.category][item.subcategory].push(item);
                return acc;
            }, {});

            setGroupedData(groupedByCategory);
        };

        groupData();
    }, [sortedRiskData]);

    const organizeGridCols = (length: number) => {
        switch (length) {
            case 1:
                return `grid-cols-1`
            case 2:
                return `grid-cols-2`
            default:
                return "grid-cols-3"
        }
    }

    const organizeBasis = (length: number) => {
        switch (length) {
            case 1:
                return 'basis-1/3'
            case 2:
                return `basis-2/3`
            default:
                return "w-full"
        }
    }

    const shouldApplyFlexGrow = (data: any) => { // aplicar flexgrow quando tiver mais de 1 linha, ou seja, mais de 3 subcategorias
        const totalSubcategories = Object.values(data).reduce((acc: number, category: any) => {
            return acc + Object.keys(category).length;
        }, 0);
        return totalSubcategories > 3;
    };

    const organizeLateralColor = (priority: string) => {
        switch (priority) {
            case "HIGH":
                return 'bg-[#FF9999]'
            case "REGULAR":
                return 'bg-[#FFE999]'
            case "LOW":
                return 'bg-[#99FFCE]'
        }
    }

    return (
        <div className="flex flex-wrap p-2 overflow-y-auto h-full">
            {Object.keys(groupedData).map((category: any) => (
                <div key={category} className={`flex ${organizeBasis(Object.keys(groupedData[category]).length)} pb-2 px-1`}>
                    <div className={`w-full flex flex-col ${Object.keys(groupedData[category]).length === 1 ? 'h-auto' : 'h-full'}`}>
                        <h2 className={`font-openSans font-semibold text-white text-left pl-3 py-1 rounded-md text-[15px] leading-[30px] tracking-[0.2px] mb-2 shadow-custom-shadow`} style={{
                            backgroundColor: designSystem?.cssBasics.primaryColor,
                        }}>
                            {category}
                        </h2>

                        <div className={`grid ${organizeGridCols(Object.keys(groupedData[category]).length)} gap-2 ${shouldApplyFlexGrow(groupedData) ? 'flex-grow' : ''}`}>
                            {Object.keys(groupedData[category]).map((subcategory: any) => (
                                <div className='bg-[#FFFFFF] shadow-custom-shadow rounded-md px-3 pb-4 m-1 flex flex-col gap-1 flex-1 mb-4' key={subcategory}>
                                    <h3 className="text-left font-openSans font-bold text-[13px] leading-[26px] tracking-[0.2px] mt-1 mb-3 rounded-md" style={{ color: `${pSBC(0.9, designSystem?.cssBasics.primaryColor)}` }}>{subcategory}</h3>

                                    <div className="font-openSans font-semibold text-center rounded-md grid grid-cols-3 gap-2 text-[11px] leading-[20px] tracking-[0.2px]">
                                        {groupedData[category][subcategory].map((risk: any) => (
                                            <Link key={risk.id}
                                                to={`/risk_theme/${risk.id}`}
                                                className={`flex items-center overflow-hidden text-left pl-3 text-[#4B4B4B] leading-[17px] p-[5px] rounded-md bg-[#FAFAFA] relative py-1.5 cursor-pointer min-h-[52px]`}>
                                                <span
                                                    className={`absolute left-0 top-0 bottom-0 w-[0.35rem] ${organizeLateralColor(risk.priority)}`}
                                                ></span>
                                                {risk.name}
                                            </Link>
                                        ))}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            ))}
        </div>
    )
}